export default __webpack_public_path__ + "static/media/pg-20.343926a8.jpg";